import { ConferenceMemberRemovedByOtherEvent, ConferenceRemovedByOtherEvent } from '@wui/im'

import { useChatMessageStore } from '@/entities/messages'
import { useStoreRooms } from '@/entities/room'

import { emitter } from '@/shared/services/emitter'
import { EmitterEvents, LeaveChatIfCurrentPayload } from '@/shared/types/emitter-events'
import { Room } from '@/shared/types/store'
import { fromPServedUser } from '@/shared/utils/uri'
import { getChatRouteId } from '@/shared/utils/url'

export const useChatCleanupHook = (room: Room, event: ConferenceRemovedByOtherEvent | ConferenceMemberRemovedByOtherEvent) => {
  const { removeRoom } = useStoreRooms()
  const { deleteMessages } = useChatMessageStore()
  const executor = fromPServedUser(event.executor)

  deleteMessages(event.pServed)
  removeRoom(room.id)

  const roomRouteId = getChatRouteId(room)
  const leavePayload: LeaveChatIfCurrentPayload | undefined = roomRouteId
    ? { roomRouteId }
    : undefined
  if (leavePayload) {
    emitter.emit(EmitterEvents.LEAVE_CHAT_IF_CURRENT, leavePayload)
  }

  const emitRemoveMemberToast = () => {
    if (event.type !== 'ConferenceMemberRemoved') {
      return
    }
    const targetNumber = event.targetNumber
    const isIAm = executor === targetNumber
    if (!isIAm) {
      emitter.emit(EmitterEvents.REMOVE_MEMBER, {
        name: room.name,
      })
    }
  }

  if (leavePayload?.didLeave) {
    emitRemoveMemberToast()
    return
  }

  if (event.type === 'ConferenceRemoved') {
    emitter.emit(EmitterEvents.DELETE_ROOM, {
      name: room.name,
    })
  } else {
    emitRemoveMemberToast()
  }
}
